import { useAuthStore } from "@/store/auth/auth.store";
import { useGeneralStore } from "@/store/general/general.store";
import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";

export class ApiService {
    /**
     * The api base
     */
    protected readonly apiBase = import.meta.env.VITE_API_URL;

    /**
     * Axios instance configured for the eco api
     */
    public axios: AxiosInstance;

    constructor() {
        this.axios = axios.create({
            baseURL: this.apiBase,
        });

        this.axios.interceptors.request.use(
            (config: InternalAxiosRequestConfig) => {
                useGeneralStore.getState().openAsyncOperation(config.url ?? "");
                config.headers.Authorization = "Bearer ".concat(
                    useAuthStore.getState().token ?? "",
                );
                return config;
            },
            (error) => {
                this.handleFinalizedRequest(error.config.url);
                return Promise.reject(error);
            },
        );

        this.axios.interceptors.response.use(
            (response) => {
                this.handleFinalizedRequest(response.config.url ?? "");
                return response;
            },
            (error) => {
                this.handleFinalizedRequest(error.config.url);
                // expire the token when a 401 error is detected
                if (error?.response?.status === 401) {
                    useAuthStore.getState().expireToken();
                }

                return Promise.reject(error);
            },
        );
    }

    /**
     * Handles a finalized request
     */
    private handleFinalizedRequest(id: string) {
        useGeneralStore.getState().closeAsyncOperation(id);
    }
}

// export const apiService = new ApiService();
